import '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterHeader/bcheader.scss';
import type { BowlingCenterContent } from '@redturtle/qubicaamf-theme/components/Blocks/BowlingCenterDescription/schema';

interface Props {
  parent: BowlingCenterContent['parent'];
  lanesnr: BowlingCenterContent['lanesnr'];
  region: BowlingCenterContent['bowling_center_region'];
}

export default function BowlingCenterHeader({
  parent,
  lanesnr,
  region,
}: Props) {
  const lanes = lanesnr === '1' ? `${lanesnr} lane` : `${lanesnr} lanes`;
  return (
    <div className="bowling-center-header">
      {region?.length > 0 && (
        <div className="item region">{region[0].title}</div>
      )}
      {lanesnr && <div className="item lanes">{lanes}</div>}
      {parent?.title && <div className="item parent">{parent.title}</div>}
    </div>
  );
}
